<script>
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Checkbox from "@/pages/components/form/horizontal/checkbox.vue";

export default {
  mixins: [formInput],
  components: {Checkbox},
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      default: 'horizontal'
    }
  },
  methods: {
    isChecked(option) {
      return this.modelValue.includes(option.value);
    }
  }
}
</script>

<template>
  <div class="d-flex column-gap-3 row-gap-2" :class="{'flex-column' : layout === 'vertical'}">
    <Checkbox
        v-bind="$attrs"
        v-for="(option, index) in options"
        :key="index"
        :model-value="modelValue"
        :form="form"
        :name="name"
        :id="`${this.renderedId}-${index}`"
        :value="option.value"
        :label="option.label"
        :checked="isChecked(option)"
        @update:modelValue="$emit('update:modelValue', $event)"
    />
  </div>
</template>